import Loadable from "@loadable/component";

export { default as ProductQuantityMob } from "./productQuantityMob";

export const ProductQuantity = Loadable(
  () =>
    import(
      /* webpackChunkName: "product_web_quantity_component" */ "./productQuantity"
    )
);
